export enum EventType {
  Death = 'death',
  PermanentWorkIncapacity = 'permanentWorkIncapacity',
  JobLoss = 'jobLoss',
  Hospitalization = 'hospitalization'
}
